export default __webpack_public_path__ + "static/media/camera-svgrepo-com.0b86ce7d.svg";